<template>
    <div id="wrapper">
        <SidebarView :reports="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />
                <div class="container">
                    <div class="card card-shape home-box">
                        <div class="card-header">
                            <div class="row align-items-center">
                                <div class="col-6">
                                    <h6 class="m-0 fw-bold text-green">
                                        Account Statistics Reports (System - Summary)
                                    </h6>
                                </div>
                                <div class="col-6 text-end">
                                    <b-button @click="generateExcel"
                                        class="btn-sm me-2 akkurate-green-btn akkurate-small">
                                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                                    </b-button>
                                    <report-filter :form="form" @filterAction="filterAction"
                                        :filter="filter"></report-filter>
                                    <b-button @click="printPDF"
                                        class="me-2 btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
                                            :icon="['fas', 'print']" /></b-button>
                                    <b-button @click="downloadPDF"
                                        class="btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
                                            :icon="['fas', 'download']" /></b-button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="container-fluid" ref="pdfContent">
                                <div class="row small">
                                    <div class="col-12 col-md-12">
                                        <statement-institution :institution="institution"
                                            :title="'ACCOUNT STATISTICS REPORT'"></statement-institution>
                                    </div>
                                    <div class="col-12 text-end text-uppercase">
                                        Reporting Month :
                                        {{
                                            new Intl.DateTimeFormat("en-GB", {
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric",
                                            }).format(new Date(form.end_date))
                                        }}
                                    </div>
                                    <hr />
                                    <div v-if="isBusy">
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="row">
                                            <div class="col-12 p-0 fw-bold mb-2">
                                                MEMBERSHIP INFORMATION
                                            </div>
                                            <div class="col-12 px-0 trans_details mb-2">
                                                <b-table-simple class="no-break" bordered responsive outlined>
                                                    <b-thead>
                                                        <b-tr variant="secondary">
                                                            <b-th class="py-1" width="50%">MEMBERS</b-th>
                                                            <b-th class="py-1">Total</b-th>
                                                            <b-th class="py-1">Females</b-th>
                                                            <b-th class="py-1">Males</b-th>
                                                            <b-th class="py-1">Groups</b-th>
                                                        </b-tr>
                                                    </b-thead>
                                                    <b-tbody>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Active Members
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    total_active_member
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    active_female
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    active_male
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    active_group
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Inactive Members
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    total_inactive_member
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    inactive_female
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    inactive_male
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    inactive_group
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Dormant Members
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    total_dormant_member
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    dormant_female
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    dormant_male
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    dormant_group
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                    </b-tbody>
                                                    <b-tfoot>
                                                        <b-tr>
                                                            <b-td class="fw-bold py-0 px-2">
                                                                Total Membership
                                                            </b-td>
                                                            <b-td class="fw-bold py-0 px-2">{{
                                                                total_member
                                                            }}</b-td>
                                                            <b-td class="fw-bold py-0 px-2">{{
                                                                total_female
                                                            }}</b-td>
                                                            <b-td class="fw-bold py-0 px-2">{{
                                                                total_male
                                                            }}</b-td>
                                                            <b-td class="fw-bold py-0 px-2">{{
                                                                total_group
                                                            }}</b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td class="fw-bold py-0 px-2">
                                                                Number of person
                                                                in group (If
                                                                Avaliable)
                                                            </b-td>
                                                            <b-td class="fw-bold py-0 px-2"></b-td>
                                                            <b-td class="fw-bold py-0 px-2"></b-td>
                                                            <b-td class="fw-bold py-0 px-2"></b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td class="fw-bold py-0 px-2">
                                                                Number of Youth
                                                                Savers (if
                                                                applicable)
                                                            </b-td>
                                                            <b-td class="fw-bold py-0 px-2"></b-td>
                                                            <b-td class="fw-bold py-0 px-2"></b-td>
                                                            <b-td class="fw-bold py-0 px-2"></b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td class="fw-bold py-0 px-2">
                                                                Number of Mobile
                                                                Banking Client
                                                                (if avalibale)
                                                            </b-td>
                                                            <b-td class="fw-bold py-0 px-2"></b-td>
                                                            <b-td class="fw-bold py-0 px-2"></b-td>
                                                            <b-td class="fw-bold py-0 px-2"></b-td>
                                                        </b-tr>
                                                    </b-tfoot>
                                                </b-table-simple>
                                            </div>
                                            <div class="col-12 p-0 fw-bold mb-2">
                                                MEMBERS DEPOSIT AND LOANS
                                            </div>

                                            <div class="col-12 px-0 trans_details">
                                                <b-table-simple class="no-break" bordered responsive outlined>
                                                    <b-thead>
                                                        <b-tr variant="secondary">
                                                            <b-th width="50%" class="py-1">MEMBERS</b-th>
                                                            <b-th class="py-1">Total</b-th>
                                                            <b-th class="py-1">Females</b-th>
                                                            <b-th class="py-1">Males</b-th>
                                                            <b-th class="py-1">Groups</b-th>
                                                        </b-tr>
                                                    </b-thead>
                                                    <b-tbody>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of Active
                                                                Shares (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        total_active_shares_members
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_female_shares
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_male_shares
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_group_shares
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of
                                                                Inactive Shares
                                                                (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        total_inactive_shares_members
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        inactive_female_shares
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        inactive_male_shares
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        inactive_group_shares
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of
                                                                Dormant Shares
                                                                (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        total_dormant_shares_members
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        dormant_female_shares
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        dormant_male_shares
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        dormant_group_shares
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr variant="secondary">
                                                            <td class="py-0 px-2 fw-bold">
                                                                Total Amount of
                                                                Shares (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        total_active_shares_members +
                                                                        total_inactive_shares_members +
                                                                        total_dormant_shares_members
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_female_shares +
                                                                        inactive_female_shares +
                                                                        dormant_female_shares
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_male_shares +
                                                                        inactive_male_shares +
                                                                        dormant_male_shares
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_group_shares +
                                                                        inactive_group_shares +
                                                                        dormant_group_shares
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of Active
                                                                Savings (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        total_active_savings_members
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_female_savings
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_male_savings
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_group_savings
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of
                                                                Inactive Savings
                                                                (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        total_inactive_savings_members
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        inactive_female_savings
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        inactive_male_savings
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        inactive_group_savings
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of
                                                                Dormant Savings
                                                                (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        total_dormant_savings_members
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        dormant_female_savings
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        dormant_male_savings
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        dormant_group_savings
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr variant="secondary">
                                                            <td class="py-0 px-2 fw-bold">
                                                                Total Amount Of Savings (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        total_active_savings_members +
                                                                        total_inactive_savings_members +
                                                                        total_dormant_savings_members
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_female_savings +
                                                                        inactive_female_savings +
                                                                        dormant_female_savings
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_male_savings +
                                                                        inactive_male_savings +
                                                                        dormant_male_savings
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        active_group_savings +
                                                                        inactive_group_savings +
                                                                        dormant_group_savings
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>

                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Number of loans
                                                                disbursed during
                                                                the period
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    total_disbursement_count
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    disbursement_female_count
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    disbursement_male_count
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    disbursement_group_count
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of loans
                                                                disbursed during
                                                                the period (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        total_disbursement_sum
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        disbursement_female_sum
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        disbursement_male_sum
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        disbursement_group_sum
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Number of Loans
                                                                Outstanding
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    total_oustanding_loan
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    oustanding_female_loan_count
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    oustanding_male_loan_count
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    oustanding_group_loan_count
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of Loans
                                                                Outstanding
                                                                (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        oustanding_loan_sum
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        oustanding_female_loan_sum
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        oustanding_male_loan_sum
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        oustanding_group_loan_sum
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                No. of
                                                                Delinquent
                                                                Borrowers
                                                                (arrears of 30
                                                                days and more):
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    total_delinquent_count
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    delinquent_female_count
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    delinquent_male_count
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    delinquent_group_count
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of
                                                                Delinquent Loans
                                                                (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        delinquent_sum
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        delinquent_female_sum
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        delinquent_male_sum
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        delinquent_group_sum
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <td class="py-0 px-2">
                                                                Amount of Youth
                                                                Savings (GH¢)
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        0
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        0
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        0
                                                                    )
                                                                }}
                                                            </td>
                                                            <td class="py-0 px-2">
                                                                {{
                                                                    displayNumber(
                                                                        0
                                                                    )
                                                                }}
                                                            </td>
                                                        </b-tr>
                                                    </b-tbody>
                                                    <b-tfoot>
                                                        <b-tr>
                                                            <b-td class="fw-bold py-0 px-2 text-end">
                                                                Deliquency Rate
                                                                (%)
                                                            </b-td>
                                                            <b-td class="fw-bold py-0 px-2">{{ Number(delinquent_sum /
                                                                oustanding_loan_sum).toFixed(2) * 100 }}%</b-td>
                                                            <b-td class="fw-bold py-0 px-2">{{
                                                                Number(delinquent_female_sum /
                                                                    oustanding_female_loan_sum).toFixed(2) * 100 }}%</b-td>
                                                            <b-td class="fw-bold py-0 px-2">{{
                                                                Number(delinquent_male_sum /
                                                                    oustanding_male_loan_sum).toFixed(2) * 100 }}%</b-td>
                                                            <b-td class="fw-bold py-0 px-2">{{
                                                                Number(delinquent_group_sum /
                                                                    oustanding_group_loan_sum).toFixed(2) * 100 }}%</b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td class="fw-bold py-0 px-2 text-end">
                                                                Standard:
                                                            </b-td>
                                                            <b-td colspan="4" class="fw-bold py-0 px-2"> Not more than
                                                                5%.</b-td>
                                                        </b-tr>
                                                    </b-tfoot>
                                                </b-table-simple>
                                            </div>

                                            <div class="col-12 p-0 fw-bold my-2">
                                                RECEIPTS AND PAYMENTS
                                            </div>
                                            <div class="col-6 col-md-6 trans_details px-0">
                                                <b-table-simple bordered responsive outlined>
                                                    <b-thead>
                                                        <b-tr variant="secondary">
                                                            <b-th class="text-center fs-6 py-1"
                                                                colspan="2"><span>Receipts</span></b-th>
                                                        </b-tr>
                                                    </b-thead>
                                                    <b-tbody>
                                                        <!-- Loop through COA heads for receipts -->
                                                        <template v-for="(coa_type, index) in coa_heads">
                                                            <b-tr>
                                                                <td class="py-0 px-2 fw-bold">
                                                                    {{ coa_type?.type_name }}
                                                                </td>
                                                            </b-tr>
                                                            <b-tr v-for="(coa_head, idx) in coa_type?.coa_heads"
                                                                :key="idx + coa_head?.display_name">
                                                                <td class="py-0 px-2">
                                                                    {{ coa_head?.display_name }}
                                                                </td>
                                                                <td class="py-0 px-2">
                                                                    {{ institution?.currency_code }} {{
                                                                        displayNumber(coa_head?.total_receipts) }}
                                                                </td>
                                                            </b-tr>
                                                            <b-tr variant="success">
                                                                <td class="py-0 px-2 fw-bold">
                                                                    TOTAL
                                                                </td>
                                                                <td class="py-0 px-2 fw-bold">
                                                                    {{ institution?.currency_code }} {{
                                                                        displayNumber(coa_type?.total_receipts) }}
                                                                </td>
                                                            </b-tr>
                                                        </template>
                                                    </b-tbody>
                                                    <b-tfoot>
                                                        <b-tr>
                                                            <b-th>Total Receipts</b-th>
                                                            <b-th>{{ institution?.currency_code }}
                                                                {{
                                                                    displayNumber(
                                                                        Number(total_receipts).toFixed(2)
                                                                    )
                                                                }}</b-th>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-th>Total Income</b-th>
                                                            <b-th>{{ institution?.currency_code }}
                                                                {{
                                                                    displayNumber(
                                                                        Number(total_incomes).toFixed(2)
                                                                    )
                                                                }}</b-th>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-th colspan="2">Profit/Loss</b-th>
                                                        </b-tr>
                                                    </b-tfoot>
                                                </b-table-simple>
                                            </div>
                                            <div class="col-6 col-md-6 trans_details px-0">
                                                <b-table-simple bordered responsive outlined>
                                                    <b-thead>
                                                        <b-tr variant="secondary">
                                                            <b-th class="text-center fs-6 py-1"
                                                                colspan="2"><span>Payments</span></b-th>
                                                        </b-tr>
                                                    </b-thead>
                                                    <b-tbody>
                                                        <!-- Loop through COA heads for payments -->
                                                        <template v-for="(coa_type, index) in coa_heads">
                                                            <b-tr>
                                                                <td class="py-0 px-2 fw-bold">
                                                                    {{ coa_type?.type_name }}
                                                                </td>
                                                            </b-tr>
                                                            <b-tr v-for="(coa_head, idx) in coa_type?.coa_heads"
                                                                :key="idx + coa_head?.display_name">
                                                                <td class="py-0 px-2">
                                                                    {{ coa_head?.display_name }}
                                                                </td>
                                                                <td class="py-0 px-2">
                                                                    {{ institution?.currency_code }} {{
                                                                        displayNumber(coa_head?.total_payments) }}
                                                                </td>
                                                            </b-tr>
                                                            <b-tr variant="danger">
                                                                <td class="py-0 px-2 fw-bold">
                                                                    TOTAL
                                                                </td>
                                                                <td class="py-0 px-2 fw-bold">
                                                                    {{ institution?.currency_code }} {{
                                                                        displayNumber(coa_type?.total_payments) }}
                                                                </td>
                                                            </b-tr>
                                                        </template>

                                                    </b-tbody>
                                                    <b-tfoot>
                                                        <b-tr>
                                                            <b-th>Total Payments</b-th>
                                                            <b-th>{{ institution?.currency_code }}
                                                                {{
                                                                    displayNumber(
                                                                        Number(total_payments).toFixed(2)
                                                                    )
                                                                }}</b-th>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-th>Total Expenses</b-th>
                                                            <b-th>{{ institution?.currency_code }}
                                                                {{
                                                                    displayNumber(
                                                                        Number(total_expenses).toFixed(2)
                                                                    )
                                                                }}</b-th>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-th colspan="2">{{
                                                                displayNumber(
                                                                    Number(difference).toFixed(2)
                                                                )
                                                            }}</b-th>
                                                        </b-tr>
                                                    </b-tfoot>
                                                </b-table-simple>
                                            </div>

                                            <div class="col-8 ps-0">
                                                <div class="fw-bold my-3">
                                                    NOTES TO THE STATEMENT OF
                                                    COMPREHENSIVE INCOME AND
                                                    EXPENSES FOR
                                                </div>
                                            </div>
                                            <div class="col-4 ps-0">
                                                <div class="fw-bold text-end my-3">
                                                    {{ getDateString }}
                                                </div>
                                            </div>

                                            <div id="income-statement" class="row">
                                                <div class="col-12 col-md-12 px-0 trans_details">
                                                    <b-table-simple responsive outlined>
                                                        <b-thead>
                                                            <b-tr>
                                                                <b-th class="text-center fs-6 akkurate-green"
                                                                    colspan="6"><span>INCOME SUMMARY</span></b-th>
                                                            </b-tr>
                                                            <b-tr>
                                                                <b-th class=""><span>GL Code</span></b-th>
                                                                <b-th class=""><span>GL Name</span></b-th>
                                                                <b-th class=""><span>Income Current
                                                                        Month</span></b-th>
                                                                <b-th class=""><span>Income Year to
                                                                        Date</span></b-th>
                                                            </b-tr>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <b-tr v-for="(income, incomeIndex) in incomes"
                                                                :key="'income-' + incomeIndex" class="list-item">
                                                                <b-td class="py-0 px-2">{{
                                                                    income.code
                                                                }}</b-td>
                                                                <b-td class="py-0 px-2">{{
                                                                    income.name
                                                                }}</b-td>
                                                                <b-td class="py-0 px-2">
                                                                    {{
                                                                        institution?.currency_code
                                                                    }}
                                                                    {{
                                                                        displayNumber(income.total_monthly_amount)
                                                                    }}
                                                                </b-td>
                                                                <b-td class="py-0 px-2">
                                                                    {{
                                                                        institution?.currency_code
                                                                    }}
                                                                    {{
                                                                        displayNumber(income.total_yearly_amount)
                                                                    }}
                                                                </b-td>
                                                            </b-tr>
                                                            <b-tr>
                                                                <b-th> Total Income </b-th>
                                                                <b-th class="py-0 px-2"></b-th>
                                                                <b-th class="py-0 px-2">
                                                                    {{ institution?.currency_code }}
                                                                    {{ displayNumber(grant_monthly_total_incomes ?
                                                                        grant_monthly_total_incomes.toFixed(2) : 0) }}
                                                                </b-th>
                                                                <b-th class="py-0 px-2">
                                                                    {{
                                                                        institution?.currency_code
                                                                    }}
                                                                    {{
                                                                        displayNumber(
                                                                            grant_yearly_total_incomes ?
                                                                                grant_yearly_total_incomes.toFixed(2) : 0
                                                                        )
                                                                    }}
                                                                </b-th>
                                                            </b-tr>
                                                        </b-tbody>
                                                        <b-thead>
                                                            <b-tr>
                                                                <b-th class="text-center fs-6 akkurate-green"
                                                                    colspan="6"><span>EXPENSES SUMMARY</span></b-th>
                                                            </b-tr>
                                                            <b-tr>
                                                                <b-th class=""><span>GL Code</span></b-th>
                                                                <b-th class=""><span>GL Name</span></b-th>
                                                                <b-th class=""><span>Expense Current Month</span></b-th>
                                                                <b-th class=""><span>Expense Year to Date</span></b-th>
                                                            </b-tr>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <b-tr v-for="(expense, expenseIndex) in expenses"
                                                                :key="'expense - ' + expenseIndex" class="list-item">
                                                                <b-td class="py-0 px-2">{{
                                                                    expense.code
                                                                }}</b-td>
                                                                <b-td class="py-0 px-2">{{
                                                                    expense.name
                                                                }}</b-td>
                                                                <b-td class="py-0 px-2">
                                                                    {{
                                                                        institution?.currency_code
                                                                    }}
                                                                    {{
                                                                        displayNumber(
                                                                            Number(
                                                                                expense.total_monthly_amount
                                                                            ).toFixed(2)
                                                                        )
                                                                    }}
                                                                </b-td>
                                                                <b-td class="py-0 px-2">
                                                                    {{
                                                                        institution?.currency_code
                                                                    }}
                                                                    {{
                                                                        displayNumber(
                                                                            Number(
                                                                                expense.total_yearly_amount
                                                                            ).toFixed(2)
                                                                        )
                                                                    }}
                                                                </b-td>
                                                            </b-tr>
                                                            <b-tr>
                                                                <b-th> Total Expenses </b-th>
                                                                <b-th class="py-0 px-2"></b-th>
                                                                <b-th class="py-0 px-2">
                                                                    {{
                                                                        institution?.currency_code
                                                                    }}
                                                                    {{
                                                                        displayNumber(
                                                                            grant_monthly_total_expenses
                                                                                ? grant_monthly_total_expenses.toFixed(
                                                                                    2
                                                                                )
                                                                                : 0
                                                                        )
                                                                    }}
                                                                </b-th>
                                                                <b-th class="py-0 px-2">
                                                                    {{
                                                                        institution?.currency_code
                                                                    }}
                                                                    {{
                                                                        displayNumber(
                                                                            grant_yearly_total_expenses
                                                                                ? grant_yearly_total_expenses.toFixed(
                                                                                    2
                                                                                )
                                                                                : 0
                                                                        )
                                                                    }}
                                                                </b-th>
                                                            </b-tr>
                                                        </b-tbody>
                                                        <b-tfoot>
                                                            <b-tr>
                                                                <b-th class="py-0 px-2">
                                                                    Profit / Loss (GHS)</b-th>
                                                                <b-th class="py-0 px-2"></b-th>
                                                                <b-th class="py-0 px-2">
                                                                    {{
                                                                        institution?.currency_code
                                                                    }}
                                                                    {{
                                                                        displayNumber(
                                                                            profit_or_loss_monthly
                                                                                ? Math.abs(
                                                                                    profit_or_loss_monthly
                                                                                ).toFixed(2)
                                                                                : 0
                                                                        )
                                                                    }}
                                                                    <span v-if="
                                                                        profit_or_loss_monthly <
                                                                        0
                                                                    ">(Loss)</span>
                                                                    <span v-else>(Profit)</span>
                                                                </b-th>
                                                                <b-th class="py-0 px-2">
                                                                    {{
                                                                        institution?.currency_code
                                                                    }}
                                                                    {{
                                                                        displayNumber(
                                                                            profit_or_loss_yearly
                                                                                ? Math.abs(
                                                                                    profit_or_loss_yearly
                                                                                ).toFixed(2)
                                                                                : 0
                                                                        )
                                                                    }}
                                                                    <span v-if="
                                                                        profit_or_loss_yearly <
                                                                        0
                                                                    ">(Loss)</span>
                                                                    <span v-else>(Profit)</span>
                                                                </b-th>
                                                            </b-tr>
                                                        </b-tfoot>
                                                    </b-table-simple>
                                                </div>
                                            </div>

                                            <div class="col-8 ps-0">
                                                <div class="fw-bold my-3">
                                                    STATEMENT OF FINANCIAL
                                                    POSITION (BALANCE SHEET) AS
                                                    AT
                                                </div>
                                            </div>
                                            <div class="col-4 ps-0">
                                                <div class="fw-bold text-end my-3">
                                                    {{ getDateString }}
                                                </div>
                                            </div>
                                            <div id="balance-sheet" class="row">
                                                <div class="col-12 col-md-12 px-0 trans_details">
                                                    <b-table-simple responsive outlined>
                                                        <b-thead>
                                                            <b-tr>
                                                                <b-th class="text-center fs-6 akkurate-green"
                                                                    colspan="6"><span>ASSESTS</span></b-th>
                                                            </b-tr>
                                                        </b-thead>
                                                        <b-thead>
                                                            <b-tr>
                                                                <b-th class=""><span>GL Code</span></b-th>
                                                                <b-th class=""><span>GL Name</span></b-th>
                                                                <b-th class=""><span></span></b-th>
                                                                <b-th class=""><span>Amount</span></b-th>
                                                                <b-th class="py-0 px-2"></b-th>
                                                            </b-tr>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <b-tr v-for="(asset, assetIndex) in assets_items"
                                                                :key="'assets-' + assetIndex" class="list-item">
                                                                <b-td class="py-0 px-2">{{
                                                                    asset.code
                                                                }}</b-td>
                                                                <b-td class="py-0 px-2">{{
                                                                    asset.display_name
                                                                }}</b-td>
                                                                <b-td></b-td>
                                                                <b-td style="font-weight: bold"
                                                                    v-if="asset.transactions.length > 0">
                                                                    {{
                                                                        institution.currency_code
                                                                    }}
                                                                    {{ displayNumber(Number(asset.total ??
                                                                        0).toFixed(2)) }}
                                                                </b-td>
                                                                <b-td style="font-weight: bold" v-else>
                                                                    {{
                                                                        institution.currency_code
                                                                    }}
                                                                    {{ displayNumber(0) }}
                                                                </b-td>
                                                                <b-th class="py-0 px-2"></b-th>
                                                            </b-tr>
                                                        </b-tbody>
                                                        <b-tbody>
                                                            <b-tr>
                                                                <b-th variant="secondary" class="py-0 px-2">Gross
                                                                    Asset</b-th>
                                                                <b-th variant="secondary"></b-th>
                                                                <b-th variant="secondary"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2">{{
                                                                    institution.currency_code
                                                                }}
                                                                    {{
                                                                        displayNumber(
                                                                            Number(
                                                                                grant_total_assets
                                                                            ).toFixed(2)
                                                                        )
                                                                    }}</b-th>
                                                                <b-th variant="secondary"></b-th>
                                                            </b-tr>

                                                            <b-tr>
                                                                <b-th variant="secondary" class="py-0 px-2">PROVISION
                                                                    FOR LOAN
                                                                    LOSSES</b-th>
                                                                <b-th variant="secondary" class="py-0 px-2"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2">{{
                                                                    institution.currency_code
                                                                }}
                                                                    {{
                                                                        displayNumber(
                                                                            Number(
                                                                                loan_losses
                                                                            ).toFixed(2)
                                                                        )
                                                                    }}</b-th>
                                                                <b-th variant="secondary"></b-th>
                                                            </b-tr>
                                                            <b-tr>
                                                                <b-th variant="secondary" class="py-0 px-2">ACCUMULATED
                                                                    DEPRECIATION</b-th>
                                                                <b-th variant="secondary" class="py-0 px-2"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2">{{
                                                                    institution.currency_code
                                                                }}
                                                                    {{ displayNumber(accumulated_dep) }}</b-th>
                                                                <b-th variant="secondary"></b-th>
                                                            </b-tr>
                                                            <b-tr>
                                                                <b-th variant="secondary" class="py-0 px-2">Net
                                                                    Asset</b-th>
                                                                <b-th variant="secondary" class="py-0 px-2"></b-th>
                                                                <b-th variant="secondary"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2">{{
                                                                    institution.currency_code
                                                                }} {{ displayNumber(net_assets) }}</b-th>
                                                                <b-th variant="secondary"></b-th>
                                                            </b-tr>
                                                        </b-tbody>
                                                        <b-thead>
                                                            <b-tr>
                                                                <b-th class="text-center fs-6 akkurate-green"
                                                                    colspan="6"><span>LIABILITIES +
                                                                        CAPITAL</span></b-th>
                                                            </b-tr>
                                                            <b-tr>
                                                                <b-th class=""><span>GL Code</span></b-th>
                                                                <b-th class=""><span>GL Name</span></b-th>
                                                                <b-th class=""><span></span></b-th>
                                                                <b-th class=""><span>Amount</span></b-th>
                                                                <b-th class="py-0 px-2"></b-th>
                                                            </b-tr>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <b-tr v-for="(liability, liabilityIndex) in liability_items"
                                                                :key="'liability - ' + liabilityIndex"
                                                                class="list-item">
                                                                <b-td class="py-0 px-2">{{ liability.code }}</b-td>
                                                                <b-td class="py-0 px-2">{{ liability.display_name
                                                                }}</b-td>
                                                                <b-td></b-td>
                                                                <b-td style="font-weight: bold"
                                                                    v-if="liability.transactions.length > 0">
                                                                    {{ institution.currency_code }}
                                                                    {{ displayNumber(Number(liability.total ??
                                                                        0).toFixed(2)) }}
                                                                </b-td>
                                                                <b-td style="font-weight: bold" v-else>
                                                                    {{ institution.currency_code }}
                                                                    {{ displayNumber(0) }}
                                                                </b-td>
                                                                <b-th class="py-0 px-2"></b-th>
                                                            </b-tr>
                                                            <!-- surpluses -->
                                                            <b-tr v-for="(value, item) in surpluses" :key="item"
                                                                class="list-item">
                                                                <b-td class="py-0 px-2">{{ liability.code }}</b-td>
                                                                <b-td style="font-weight: bold">{{ value.display_name
                                                                }}</b-td>
                                                                <b-td></b-td>
                                                                <b-td>
                                                                    <span style=" font-weight: bold; "
                                                                        v-if="value.transactions.length > 0">
                                                                        {{ institution.currency_code }}
                                                                        {{ displayNumber(value.transactions[0].balance)
                                                                        }}
                                                                    </span>
                                                                    <span style="font-weight: bold;" v-else>
                                                                        {{ institution.currency_code }} 0
                                                                    </span>
                                                                </b-td>
                                                                <b-th class="py-0 px-2"></b-th>
                                                            </b-tr>
                                                        </b-tbody>
                                                        <b-tbody>
                                                            <b-tr>
                                                                <b-th variant="secondary" class="py-0 px-2">Total
                                                                    Liability</b-th>
                                                                <b-th variant="secondary"></b-th>
                                                                <b-th variant="secondary">
                                                                </b-th>
                                                                <b-th variant="secondary" class="py-0 px-2">{{
                                                                    institution.currency_code
                                                                }}
                                                                    {{
                                                                        displayNumber(
                                                                            Number(
                                                                                grant_total_liabilities
                                                                            ).toFixed(2)
                                                                        )
                                                                    }}</b-th>
                                                                <b-th variant="secondary"></b-th>
                                                            </b-tr>

                                                            <b-tr>
                                                                <b-th variant="secondary" class="py-0 px-2">Total
                                                                    Surplus</b-th>
                                                                <b-th variant="secondary" class="py-0 px-2"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2">{{
                                                                    institution.currency_code
                                                                }}
                                                                    {{
                                                                        displayNumber(
                                                                            Number(
                                                                                grant_total_surpluses
                                                                            ).toFixed(2)
                                                                        )
                                                                    }}</b-th>
                                                                <b-th variant="secondary"></b-th>
                                                            </b-tr>
                                                            <b-tr>
                                                                <b-th variant="secondary" class="py-0 px-2">Total
                                                                    Liabilities +
                                                                    Surplus</b-th>
                                                                <b-th variant="secondary" class="py-0 px-2"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2"></b-th>
                                                                <b-th variant="secondary" class="py-0 px-2">{{
                                                                    institution.currency_code }}
                                                                    {{
                                                                        displayNumber(
                                                                            Number(
                                                                                liabilities_plus_surplus
                                                                            ).toFixed(2)
                                                                        )
                                                                    }}</b-th>
                                                                <b-th variant="secondary"></b-th>
                                                            </b-tr>
                                                        </b-tbody>
                                                        <b-thead>
                                                            <b-tr>
                                                                <b-th class="text-center fs-6 akkurate-green"
                                                                    colspan="6"><span>
                                                                        Information on
                                                                        Ratio</span></b-th>
                                                            </b-tr>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <b-tr class="trans_details">
                                                                <b-th class="py-0 px-2">Liquidity Reserve</b-th>
                                                                <b-th class="py-0 px-2">{{ liquidity_res }} %</b-th>
                                                                <b-th class="py-0 px-2" colspan="2">(Total liquid Funds
                                                                    / total assets * 100)</b-th>
                                                            </b-tr>
                                                            <b-tr class="trans_details">
                                                                <b-th class="">Return on Asset</b-th>
                                                                <b-th class="">{{
                                                                    return_on_assets
                                                                }}
                                                                    %</b-th>
                                                                <b-th class="py-0 px-2" colspan="2">(Surplus difference
                                                                    / total
                                                                    assets * 100)</b-th>
                                                            </b-tr>
                                                            <b-tr class="trans_details">
                                                                <b-th class="py-0 px-2">Capital Adequacy</b-th>
                                                                <b-th class="py-0 px-2">{{
                                                                    capital_adequacy
                                                                }}
                                                                    %</b-th>
                                                                <b-th class="py-0 px-2" colspan="2">([Member Shares +
                                                                    total
                                                                    capital res] / total assets
                                                                    * 100)</b-th>
                                                            </b-tr>
                                                            <b-tr class="trans_details">
                                                                <b-th class="py-0 px-2">Prepared By</b-th>
                                                                <b-th class="py-0 px-2"></b-th>
                                                                <b-th class="py-0 px-2">Certified By</b-th>
                                                                <b-th class=""></b-th>
                                                            </b-tr>
                                                            <b-tr class="trans_details">
                                                                <b-th class="py-0 px-2">Accountant</b-th>
                                                                <b-th class="py-0 px-2"></b-th>
                                                                <b-th class="py-0 px-2">Manager/Board
                                                                    Treasurer</b-th>
                                                                <b-th class=""></b-th>
                                                            </b-tr>
                                                            <b-tr class="trans_details">
                                                                <b-th class="py-0 px-2">Signature</b-th>
                                                                <b-th class="py-0 px-2"></b-th>
                                                                <b-th class="py-0 px-2">Signature</b-th>
                                                                <b-th class=""></b-th>
                                                            </b-tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </div>
                                            </div>


                                            <div class="col-8 ps-0">
                                                <div class="fw-bold my-3">
                                                    OTHER INFORMATION
                                                </div>
                                            </div>
                                            <div class="col-4 ps-0">
                                                <div class="fw-bold text-end my-3">
                                                    {{ getDateString }}
                                                </div>
                                            </div>
                                            <div class="col-12 col-6 col-md-12 trans_details px-0">
                                                <b-table-simple class="no-break" bordered outlined>
                                                    <b-thead>
                                                        <b-tr variant="secondary">
                                                            <b-th class="py-1"></b-th>
                                                            <b-th class="py-1">In Place
                                                                (Yes/No)</b-th>
                                                            <b-th class="py-1">Regular
                                                                Meetings
                                                                Date</b-th>
                                                            <b-th class="py-1">No of meeting
                                                                in period</b-th>
                                                        </b-tr>
                                                    </b-thead>
                                                    <b-tbody>
                                                        <b-tr>
                                                            <b-td>Management Committee</b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td>Supervisory Committee</b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td>Loan Committee</b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td>Education Committee</b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                        </b-tr>
                                                    </b-tbody>
                                                </b-table-simple>
                                            </div>

                                            <div class="col-8 ps-0">
                                                <div class="fw-bold my-3">
                                                    EMPLOYEES INFORMATION
                                                </div>
                                            </div>
                                            <div class="col-4 ps-0">
                                                <div class="fw-bold text-end my-3">
                                                    {{ getDateString }}
                                                </div>
                                            </div>
                                            <div class="col-12 col-6 col-md-12 trans_details px-0">
                                                <b-table-simple class="no-break" bordered outlined>
                                                    <b-thead>
                                                        <b-tr variant="secondary">
                                                            <b-th class="py-1"></b-th>
                                                            <b-th class="py-1">Total</b-th>
                                                            <b-th class="py-1">Male</b-th>
                                                            <b-th class="py-1">Female</b-th>
                                                        </b-tr>
                                                    </b-thead>
                                                    <b-tbody>
                                                        <b-tr>
                                                            <b-td>No of Permanent
                                                                Employees</b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td>No of Temporal
                                                                Employees</b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td>No of Employees
                                                                covered under
                                                                CCUPP</b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                            <b-td></b-td>
                                                        </b-tr>
                                                    </b-tbody>
                                                    <b-tfoot>
                                                        <b-tr>
                                                            <b-th>Total Number Of
                                                                Employees</b-th>
                                                            <b-th></b-th>
                                                            <b-th></b-th>
                                                            <b-th></b-th>
                                                        </b-tr>
                                                    </b-tfoot>
                                                </b-table-simple>
                                            </div>
                                            <div class="col-6">
                                                <div>Prepared By:</div>
                                            </div>
                                            <div class="col-6">
                                                <div>Approved By:</div>
                                            </div>

                                            <div class="col-4">
                                                <div class="text-start">
                                                    ____________________________________
                                                </div>
                                                <div class="text-start">
                                                    Signature
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="text-start">
                                                    ____________________________________
                                                </div>
                                                <div class="text-start">
                                                    Signature
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="text-start">
                                                    ____________________________________
                                                </div>
                                                <div class="text-start">
                                                    Signature
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top">
            <i class="fas fa-angle-up"></i>
        </a>
    </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import ReportFilter from "../form/ReportFilter.vue";
import html2pdf from "html2pdf.js";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        StatementInstitution,
        Multiselect,
        ReportFilter,
        ChatBot,
    },
    data() {
        return {
            form: {
                start_date: this.getBeginningOfYear(),
                end_date: new Date().toISOString().split("T")[0],
                branches: [],
                products: [],
                branch_options: [],
                product_options: [],
                users: [],
                users_options: [],
                status: [],
                coa: [],
                coa_options: [],
                terms: "YTD",
                terms_options: ["YTD", "Periodic"],
                categories: [],
                loan_status: [],
            },
            filter: {
                branches: true,
                products: false,
                users: false,
                status: false,
                condition: false,
                terms: false,
                coa: false,
                voucher_status: false,
                end_date: true,
                loan_status: false
            },
            search: "Search",
            isBusy: false,
            dropdownsiBusy: false,
            isSearching: false,
            isLoadingInstitution: false,
            rec_items: [],
            rec_total: "",
            pay_items: [],
            pay_total: "",
            institution: "",
            active_male: 0,
            active_female: 0,
            active_group: 0,
            inactive_male: 0,
            inactive_female: 0,
            inactive_group: 0,
            dormant_male: 0,
            dormant_female: 0,
            dormant_group: 0,
            total_female: 0,
            total_male: 0,
            total_group: 0,
            total_active: 0,
            total_inactive: 0,
            total_dormant: 0,
            member_total: 0,
            sumAssetsTotal: 0,
            no_of_branches: 0,
            total_active_member: 0,
            total_inactive_member: 0,
            total_dormant_member: 0,
            total_member: 0,
            active_female_shares: 0,
            active_male_shares: 0,
            active_group_shares: 0,
            inactive_female_shares: 0,
            inactive_male_shares: 0,
            inactive_group_shares: 0,
            dormant_female_shares: 0,
            dormant_male_shares: 0,
            dormant_group_shares: 0,
            active_female_savings: 0,
            active_male_savings: 0,
            active_group_savings: 0,
            inactive_female_savings: 0,
            inactive_male_savings: 0,
            inactive_group_savings: 0,
            dormant_female_savings: 0,
            dormant_male_savings: 0,
            dormant_group_savings: 0,
            disbursement_female_count: 0,
            disbursement_male_count: 0,
            disbursement_group_count: 0,
            disbursement_female_sum: 0,
            disbursement_male_sum: 0,
            disbursement_group_sum: 0,
            sub_total_receipt: 0,
            sub_total_payment: 0,

            oustanding_female_loan_count: 0,
            oustanding_male_loan_count: 0,
            oustanding_group_loan_count: 0,
            oustanding_female_loan_sum: 0,
            oustanding_male_loan_sum: 0,
            oustanding_group_loan_sum: 0,

            delinquent_female_count: 0,
            delinquent_male_count: 0,
            delinquent_group_count: 0,

            delinquent_female_sum: 0,
            delinquent_male_sum: 0,
            delinquent_group_sum: 0,

            total_active_shares_members: 0,
            total_inactive_shares_members: 0,
            total_dormant_shares_members: 0,

            total_active_savings_members: 0,
            total_inactive_savings_members: 0,
            total_dormant_savings_members: 0,

            total_disbursement_count: 0,
            total_disbursement_sum: 0,

            total_oustanding_loan: 0,
            total_delinquent_count: 0,
            oustanding_loan_sum: 0,
            delinquent_sum: 0,

            beg_of_month_cash: 0,
            shares_member_deposit: 0,
            saving_member_deposit: 0,
            loan_repayment: 0,


            coa_heads: [],
            total_receipts: 0,
            total_payments: 0,

            grant_monthly_total_incomes: 0,
            grant_yearly_total_incomes: 0,
            grant_monthly_total_expenses: 0,
            grant_yearly_total_expenses: 0,
            grant_total_expenses: 0,
            profit_or_loss_monthly: 0,
            profit_or_loss_yearly: 0,
            coa_heads_receipts: [],
            coa_heads_payments: [],

            incomes: [],
            expenses: [],

            assets: [],
            liabilities: [],

            total_assets: 0,
            loan_losses: 0,
            accumulated_dep: 0,

            total_liability: 0,
            total_surpluses: 0,

            provisions: [],
            assets_items: [],
            liability_items: [],
            surpluses: [],

            total_income: 0,
            total_expenses: 0,
            net_assets: 0,

            grant_total_assets: 0,
            liquid_funds: 0,
            grant_total_assets: 0,
            grant_total_surpluses:0,
        };
    },

    created() {
        this.getInstitution();
        this.getAccountStatistics();
        this.getProductDropdown();
    },
    computed: {
        totalIncome() {
            return this.incomes?.reduce((total, item) => total + parseFloat(item.total_monthly_amount), 0).toFixed(2);
        },
        // Total Expenses
        totalExpenses() {
            return this.expenses?.reduce((total, item) => total + parseFloat(item.total_monthly_amount), 0).toFixed(2);
        },
        // Total Yearly Income
        totalYearlyIncome() {
            return this.incomes?.reduce((total, item) => total + parseFloat(item.total_yearly_amount), 0).toFixed(2);
        },
        // Total Yearly Expenses
        totalYearlyExpenses() {
            return this.expenses?.reduce((total, item) => total + parseFloat(item.total_yearly_amount), 0).toFixed(2);
        },
        // Total LiquidFunds
        totalLiquidFunds() {
            return this.getCOAHead(this.assets, "liquid-fund")?.[0];
        },
        liquidity_res() {
            console.log(this.liquid_funds, this.grant_total_assets);
            return (
                Number((this.liquid_funds / this.grant_total_assets) * 100).toFixed(2) ?? 0
            );
        },

        return_on_assets() {
            return (
                Number(
                    (this.grant_total_surpluses / this.grant_total_assets) *
                    100
                ).toFixed(2) ?? 0
            );
        },
        capital_adequacy() {
            return (
                Number(
                    ((this.member_shares + this.reserves) /
                        this.grant_total_assets) *
                    100
                ).toFixed(2) ?? 0
            );
        },
        deliquencyRate() {
            return Number(
                (this.delinquent_sum / this.oustanding_loan_sum) * 100
            ).toFixed(2);
        },
        getDateString() {
            const date = new Date(this.form.end_date); // Current date
            const options = { year: "numeric", month: "long" };
            const formattedDate = date.toLocaleDateString("en-US", options);
            return formattedDate;
        },
    },

    methods: {
        getCOAHead(arr, name) {
            // console.log(arr);
            const liquidFundItems = arr.filter((item) =>
                item.short_name.toLowerCase().includes(name)
            );
            // console.log(liquidFundItems);
            return liquidFundItems.map((item) => item.amount);
        },
        async getAccountStatistics() {
            this.items = [];
            this.isBusy = true;
            this.search = "Processing...";
            this.isSearching = true;
            await ApiService.query("/reports/account/statistics/default", {
                params: {
                    startDate: this.form.start_date,
                    endDate: this.form.end_date,
                    branch_ids: this.form.branches.map((index) => {
                        return index.id;
                    }),
                    term: this.form.terms
                },
            }).then((response) => {
                this.isBusy = false;
                this.search = "Search";
                this.isSearching = false;
                const res = response.data;
                // console.log(res);
                this.no_of_branches = res.total_branch;
                this.active_female = res.active_female;
                this.active_male = res.active_male;
                this.active_group = res.active_group;
                this.inactive_female = res.inactive_female;
                this.inactive_male = res.inactive_male;
                this.inactive_group = res.inactive_group;
                this.dormant_female = res.dormant_female;
                this.dormant_male = res.dormant_male;
                this.dormant_group = res.dormant_group;
                this.total_female =
                    Number(this.active_female) +
                    Number(this.inactive_female) +
                    Number(this.dormant_female);
                this.total_male =
                    Number(this.active_male) +
                    Number(this.inactive_male) +
                    Number(this.dormant_male);
                this.total_group =
                    Number(this.active_group) +
                    Number(this.inactive_group) +
                    Number(this.dormant_group);

                this.total_active_member =
                    Number(this.active_male) +
                    Number(this.active_female) +
                    Number(this.active_group);
                this.total_inactive_member =
                    Number(this.inactive_male) +
                    Number(this.inactive_female) +
                    Number(this.inactive_group);
                this.total_dormant_member =
                    Number(this.dormant_male) +
                    Number(this.dormant_female) +
                    Number(this.dormant_group);

                this.total_member =
                    this.total_active_member +
                    this.total_inactive_member +
                    this.total_dormant_member;

                this.active_female_shares = Number(
                    res.active_female_shares
                );
                this.active_male_shares = Number(
                    res.active_male_shares
                );
                this.active_group_shares = Number(
                    res.active_group_shares
                );
                this.inactive_female_shares = Number(
                    res.inactive_female_shares
                );
                this.inactive_male_shares = Number(
                    res.inactive_male_shares
                );
                this.inactive_group_shares = Number(
                    res.inactive_group_shares
                );
                this.dormant_female_shares = Number(
                    res.dormant_female_shares
                );
                this.dormant_male_shares = Number(
                    res.dormant_male_shares
                );
                this.dormant_group_shares = Number(
                    res.dormant_group_shares
                );

                this.total_active_shares_members =
                    Number(this.active_female_shares) +
                    Number(this.active_male_shares) +
                    Number(this.active_group_shares);
                this.total_inactive_shares_members =
                    Number(this.inactive_female_shares) +
                    Number(this.inactive_male_shares) +
                    Number(this.inactive_group_shares);
                this.total_dormant_shares_members =
                    Number(this.dormant_female_shares) +
                    Number(this.dormant_male_shares) +
                    Number(this.dormant_group_shares);

                this.active_female_savings = Number(
                    res.active_female_savings
                );
                this.active_male_savings = Number(
                    res.active_male_savings
                );
                this.active_group_savings = Number(
                    res.active_group_savings
                );
                this.inactive_female_savings = Number(
                    res.inactive_female_savings
                );
                this.inactive_male_savings = Number(
                    res.inactive_male_savings
                );
                this.inactive_group_savings = Number(
                    res.inactive_group_savings
                );
                this.dormant_female_savings = Number(
                    res.dormant_female_savings
                );
                this.dormant_male_savings = Number(
                    res.dormant_male_savings
                );
                this.dormant_group_savings = Number(
                    res.dormant_group_savings
                );

                this.total_active_savings_members =
                    Number(this.active_female_savings) +
                    Number(this.active_male_savings) +
                    Number(this.active_group_savings);
                this.total_inactive_savings_members =
                    Number(this.inactive_female_savings) +
                    Number(this.inactive_male_savings) +
                    Number(this.inactive_group_savings);
                this.total_dormant_savings_members =
                    Number(this.dormant_female_savings) +
                    Number(this.dormant_male_savings) +
                    Number(this.dormant_group_savings);

                this.disbursement_female_count = Number(
                    res.disbursement_female_count
                );
                this.disbursement_male_count = Number(
                    res.disbursement_male_count
                );
                this.disbursement_group_count = Number(
                    res.disbursement_group_count
                );
                this.disbursement_female_sum = Number(
                    res.disbursement_female_sum
                );
                this.disbursement_male_sum = Number(
                    res.disbursement_male_sum
                );
                this.disbursement_group_sum = Number(
                    res.disbursement_group_sum
                );

                this.total_disbursement_count =
                    Number(this.disbursement_female_count) +
                    Number(this.disbursement_male_count) +
                    Number(this.disbursement_group_count);
                this.total_disbursement_sum =
                    Number(this.disbursement_female_sum) +
                    Number(this.disbursement_male_sum) +
                    Number(this.disbursement_group_sum);

                this.oustanding_female_loan_count = Number(
                    res.oustanding_female_loan_count
                );
                this.oustanding_male_loan_count = Number(
                    res.oustanding_male_loan_count
                );
                this.oustanding_group_loan_count = Number(
                    res.oustanding_group_loan_count
                );

                this.total_oustanding_loan =
                    Number(this.oustanding_female_loan_count) +
                    Number(this.oustanding_male_loan_count) +
                    Number(this.oustanding_group_loan_count);

                this.delinquent_female_count = Number(
                    res.delinquent_female_count
                );
                this.delinquent_male_count = Number(
                    res.delinquent_male_count
                );
                this.delinquent_group_count = Number(
                    res.delinquent_group_count
                );

                this.total_delinquent_count =
                    Number(this.delinquent_female_count) +
                    Number(this.delinquent_male_count) +
                    Number(this.delinquent_group_count);

                this.oustanding_female_loan_sum = Number(
                    res.oustanding_female_loan_sum
                );
                this.oustanding_male_loan_sum = Number(
                    res.oustanding_male_loan_sum
                );
                this.oustanding_group_loan_sum = Number(
                    res.oustanding_group_loan_sum
                );

                this.oustanding_loan_sum =
                    Number(this.oustanding_female_loan_sum) +
                    Number(this.oustanding_male_loan_sum) +
                    Number(this.oustanding_group_loan_sum);

                this.oustanding_female_loan_sum = Number(
                    res.oustanding_female_loan_sum
                );
                this.oustanding_male_loan_sum = Number(
                    res.oustanding_male_loan_sum
                );
                this.oustanding_group_loan_sum = Number(
                    res.oustanding_group_loan_sum
                );

                this.delinquent_female_sum = Number(
                    res.delinquent_female_sum
                );
                this.delinquent_male_sum = Number(
                    res.delinquent_male_sum
                );
                this.delinquent_group_sum = Number(
                    res.delinquent_group_sum
                );

                this.delinquent_sum =
                    Number(this.delinquent_female_sum) +
                    Number(this.delinquent_male_sum) +
                    Number(this.delinquent_group_sum);

                this.transaction_female = Number(
                    res.transaction_female
                );
                this.transaction_male = Number(res.transaction_male);
                this.transaction_group = Number(res.transaction_group);

                this.coa_heads = res.receipt_and_payment?.grouped_coa;
                this.net_cash_flow = res.receipt_and_payment?.net_cash_flow || 0;

                this.total_receipts = res.receipt_and_payment?.total_receipts || 0;
                this.total_payments = res.receipt_and_payment?.total_payments || 0;

                this.total_incomes = res.receipt_and_payment?.grant_monthly_total_incomes || 0;
                this.total_expenses = res.receipt_and_payment?.grant_monthly_total_expenses || 0;

                this.difference = this.total_incomes - this.total_expenses || 0



                this.cr_sub_total = Number(this.shares_member_deposit) +
                    Number(this.saving_member_deposit) +
                    Number(this.loan_repayment) +
                    Number(this.bank_current_cr) +
                    Number(this.cff_cr) +
                    Number(this.t_bills_discount) +
                    Number(this.other_payment);

                this.shares_member_withdraw = Number(
                    res.shares_member_withdraw
                );
                this.saving_member_withdraw = Number(
                    res.saving_member_withdraw
                );
                this.loan_disbursed = Number(res.loan_disbursed);
                this.bank_current_dr = Number(res.bank_current_dr);

                this.cff_dr = Number(res.cff_dr);
                this.t_bills_invest = Number(res.t_bills_invest);
                this.other_receipts = Number(res.other_receipts);

                this.dr_sub_total =
                    Number(this.shares_member_withdraw) +
                    Number(this.saving_member_withdraw) +
                    Number(this.loan_disbursed) +
                    Number(this.bank_current_dr) +
                    Number(this.cff_dr) +
                    Number(this.t_bills_invest) +
                    Number(this.other_receipts);

                this.mobile_withdraw = Number(res.mobile_withdraw);
                this.sumRecTotal =
                    Number(this.cr_sub_total) +
                    Number(this.mobile_deposit) +
                    Number(this.totalIncome);
                this.sumPayTotal =
                    Number(this.dr_sub_total) +
                    Number(this.mobile_withdraw) +
                    Number(this.totalExpenses);
                // this.total_assets = res.balance_sheets?.grant_total_assets;
                // this.total_liability = res.balance_sheets?.grant_total_liabilities
                // this.total_surpluses = res.balance_sheets?.total_surpluses
                this.loan_losses = res.loan_losses
                this.accumulated_dep = res.accumulated_dep
                this.surplus = Number(this?.total_monthly_income) - Number(this?.total_monthly_expenses);


                this.incomes = res.income_expenses?.incomes;
                this.expenses = res.income_expenses?.expenses;
                this.grant_monthly_total_incomes = res.income_expenses?.grant_monthly_total_incomes;
                this.grant_yearly_total_incomes = res.income_expenses?.grant_yearly_total_incomes;
                this.grant_monthly_total_expenses = res.income_expenses?.grant_monthly_total_expenses;
                this.grant_yearly_total_expenses = res.income_expenses?.grant_yearly_total_expenses;
                this.grant_total_expenses = res.income_expenses?.grant_total_expenses;
                this.profit_or_loss_monthly = this.grant_monthly_total_incomes - this.grant_monthly_total_expenses;
                this.profit_or_loss_yearly = this.grant_yearly_total_incomes - this.grant_yearly_total_expenses;

                this.assets_items = res.balance_sheets?.assets;
                this.liability_items = res.balance_sheets?.liabilities;
                this.surpluses = res.balance_sheets?.surpluses;
                this.grant_total_assets = res.balance_sheets?.grant_total_assets;
                this.grant_total_liabilities = res.balance_sheets?.grant_total_liabilities;
                this.grant_total_surpluses = res.balance_sheets?.total_surpluses;
                this.liabilities_plus_surplus = this.grant_total_liabilities + this.grant_total_surpluses;
                this.net_assets = res.balance_sheets?.net_assets;
                this.start_date = this.form.start_date;
                this.end_date = this.form.end_date;
                this.provisions = res.balance_sheets?.provisions;
                this.loan_to_member = res.balance_sheets?.loan_to_member;
                this.loan_losses = res.balance_sheets?.loan_losses;
                this.accumulated_dep = res.balance_sheets?.accumulated_dep;
                this.liquid_funds = res.balance_sheets?.liquid_funds;
                this.reserves = res.balance_sheets?.reserves;
                this.member_shares = res.balance_sheets?.member_shares;

                // console.log(this.grant_total_assets);
                // console.log(this.liquid_funds);
            })
                .catch((error) => {
                    this.isBusy = false;
                    this.search = "Search";
                    this.isSearching = false;
                    // console.log(error);
                });
        },
        filterAction() {
            this.getAccountStatistics();
        },
        async getProductDropdown() {
            this.dropdownsiBusy = true;
            this.search = "Processing...";
            await ApiService.query("/reports/controls/products/dropdown")
                .then((response) => {
                    this.dropdownsiBusy = false;
                    this.search = "Search";
                    this.form.branch_options = response.data.branches;
                    this.form.product_options = response.data.products;
                    this.form.users_options = response.data.users;
                })
                .catch((error) => {
                    console.log(error);
                    this.dropdownsiBusy = false;
                    this.search = "Search";
                });
        },
        pdfOptions() {
            return {
                margin: [0.3, 0.2, 0.8, 0.2], // top, left, bottom, right
                filename: "account_statistics.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2 },
                pagebreak: { mode: ['css', 'legacy'] },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait",
                },
            };
        },
        downloadPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            html2pdf()
                .from(content)
                .set(this.pdfOptions())
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(
                            [
                                "For Inquiries, Please Contact " +
                                insit_name +
                                ", Customer Service on " +
                                insit_tele +
                                "",
                                "or email us on " +
                                insit_email +
                                " " +
                                insit_motto +
                                "",
                                "Page " + i + " of " + totalPages,
                            ],
                            pdf.internal.pageSize.getWidth() / 2,
                            pdf.internal.pageSize.getHeight() - 0.6,
                            { align: "center" }
                        );
                    }
                })
                .save();
        },
        printPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            html2pdf()
                .from(content)
                .set(this.pdfOptions())
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(
                            [
                                "For Inquiries, Please Contact " +
                                insit_name +
                                ", Customer Service on " +
                                insit_tele +
                                "",
                                "or email us on " +
                                insit_email +
                                " " +
                                insit_motto +
                                "",
                                "Page " + i + " of " + totalPages,
                            ],
                            pdf.internal.pageSize.getWidth() / 2,
                            pdf.internal.pageSize.getHeight() - 0.6,
                            { align: "center" }
                        );
                    }
                    // Get the blob of the PDF
                    return pdf.output("blob");
                })
                .then((pdfBlob) => {
                    // Create a URL for the PDF blob
                    var pdfUrl = URL.createObjectURL(pdfBlob);

                    // Open the URL in a new tab
                    const printWindow = window.open(
                        pdfUrl,
                        "_blank",
                        "width=800,height=600"
                    );
                    printWindow.onload = () => {
                        printWindow.print();
                        URL.revokeObjectURL(pdfUrl);
                    };
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                });
        },
        filterTable() {
            this.getAccountStatistics();
        },
        async getInstitution() {
            this.isLoadingInstitution = true;
            await ApiService.get("/settings/institution")
                .then((response) => {
                    this.institution = response.data.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoadingInstitution = false;
                });
        },
        cleanNumber(value) {
            // Convert to a string, then remove any extraneous spaces or non-numeric characters
            const cleanedValue = value?.toString().replace(/[^\d.-]/g, "");
            // Parse it into a float and handle NaN cases
            const parsedValue = parseFloat(cleanedValue);

            // Ensure it's a valid number, otherwise default to 0
            return isNaN(parsedValue) ? 0 : parsedValue;
        },

        // async generateExcel() {
        //     const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx";
        //     const imageUrl = "/default_logo.png";

        //     // Institution details
        //     const institutionName = this.institution?.name || "";
        //     const institutionMotto = this.institution?.motto || "";
        //     const institutionAddress = this.institution?.address || "";
        //     const institutionPhone = this.institution?.telephone || "";
        //     const institutionEmail = this.institution?.email || "";
        //     const dateRange = `FROM: ${this.form.start_date} TO: ${this.form.end_date}`;

        //     try {
        //         // Fetch and load template
        //         const response = await fetch(fileUrl);
        //         if (!response.ok) throw new Error(`Failed to fetch template: ${response.statusText}`);
        //         const arrayBuffer = await response.arrayBuffer();
        //         const wb = new ExcelJS.Workbook();
        //         await wb.xlsx.load(arrayBuffer);
        //         const ws = wb.getWorksheet(1);

        //         // Add logo
        //         const imageResponse = await fetch(imageUrl);
        //         const imageBuffer = await imageResponse.arrayBuffer();
        //         const imageId = wb.addImage({ buffer: imageBuffer, extension: "png" });
        //         ws.addImage(imageId, { tl: { col: 0, row: 0 }, ext: { width: 150, height: 80 } });

        //         // Institution details
        //         ws.getCell("E1").value = institutionName;
        //         ws.getCell("E2").value = institutionAddress;
        //         ws.getCell("E3").value = institutionMotto;
        //         ws.getCell("E4").value = institutionPhone;
        //         ws.getCell("E5").value = institutionEmail;
        //         ws.getCell("E6").value = dateRange;

        //         let row = 10;

        //         // MEMBERSHIP INFORMATION
        //         ws.getCell(`A${row}`).value = "MEMBERSHIP INFORMATION";
        //         ws.getCell(`A${row}`).font = { bold: true, size: 14 };
        //         row++;

        //         ws.getRow(row).values = ["", "Total", "Females", "Males", "Groups"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         ws.getRow(row).values = [
        //             "Active Members",
        //             this.total_active_member,
        //             this.active_female,
        //             this.active_male,
        //             this.active_group
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Inactive Members",
        //             this.total_inactive_member,
        //             this.inactive_female,
        //             this.inactive_male,
        //             this.inactive_group
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Dormant Members",
        //             this.total_dormant_member,
        //             this.dormant_female,
        //             this.dormant_male,
        //             this.dormant_group
        //         ]; row++;

        //         // Total Membership row with bold formatting
        //         const totalMembershipRow = ws.getRow(row);
        //         totalMembershipRow.values = [
        //             "Total Membership",
        //             this.total_member,
        //             this.total_female,
        //             this.total_male,
        //             this.total_group
        //         ];
        //         totalMembershipRow.font = { bold: true };
        //         row++;

        //         // Additional membership rows
        //         ws.getRow(row).values = [
        //             "Number of person in group (If Available)",
        //             "",
        //             "",
        //             "",
        //             ""
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Number of Youth Savers (if applicable)",
        //             "",
        //             "",
        //             "",
        //             ""
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Number of Mobile Banking Client (if available)",
        //             "",
        //             "",
        //             "",
        //             ""
        //         ]; row += 3;

        //         // MEMBERS DEPOSIT AND LOANS
        //         ws.getCell(`A${row}`).value = "MEMBERS DEPOSIT AND LOANS";
        //         ws.getCell(`A${row}`).font = { bold: true, size: 14 };
        //         row++;

        //         ws.getRow(row).values = ["", "Total", "Females", "Males", "Groups"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         // Shares section
        //         ws.getRow(row).values = [
        //             "Amount of Active Shares (GH¢)",
        //             this.displayNumber(this.total_active_shares_members),
        //             this.displayNumber(this.active_female_shares),
        //             this.displayNumber(this.active_male_shares),
        //             this.displayNumber(this.active_group_shares)
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Amount of Inactive Shares (GH¢)",
        //             this.displayNumber(this.total_inactive_shares_members),
        //             this.displayNumber(this.inactive_female_shares),
        //             this.displayNumber(this.inactive_male_shares),
        //             this.displayNumber(this.inactive_group_shares)
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Amount of Dormant Shares (GH¢)",
        //             this.displayNumber(this.total_dormant_shares_members),
        //             this.displayNumber(this.dormant_female_shares),
        //             this.displayNumber(this.dormant_male_shares),
        //             this.displayNumber(this.dormant_group_shares)
        //         ]; row++;

        //         // Total Shares row with bold formatting
        //         const totalSharesRow = ws.getRow(row);
        //         totalSharesRow.values = [
        //             "Total Amount of Shares (GH¢)",
        //             this.displayNumber(this.total_active_shares_members + this.total_inactive_shares_members + this.total_dormant_shares_members),
        //             this.displayNumber(this.active_female_shares + this.inactive_female_shares + this.dormant_female_shares),
        //             this.displayNumber(this.active_male_shares + this.inactive_male_shares + this.dormant_male_shares),
        //             this.displayNumber(this.active_group_shares + this.inactive_group_shares + this.dormant_group_shares)
        //         ];
        //         totalSharesRow.font = { bold: true };
        //         row++;

        //         // Savings section
        //         ws.getRow(row).values = [
        //             "Amount of Active Savings (GH¢)",
        //             this.displayNumber(this.total_active_savings_members),
        //             this.displayNumber(this.active_female_savings),
        //             this.displayNumber(this.active_male_savings),
        //             this.displayNumber(this.active_group_savings)
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Amount of Inactive Savings (GH¢)",
        //             this.displayNumber(this.total_inactive_savings_members),
        //             this.displayNumber(this.inactive_female_savings),
        //             this.displayNumber(this.inactive_male_savings),
        //             this.displayNumber(this.inactive_group_savings)
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Amount of Dormant Savings (GH¢)",
        //             this.displayNumber(this.total_dormant_savings_members),
        //             this.displayNumber(this.dormant_female_savings),
        //             this.displayNumber(this.dormant_male_savings),
        //             this.displayNumber(this.dormant_group_savings)
        //         ]; row++;

        //         // Total Savings row with bold formatting
        //         const totalSavingsRow = ws.getRow(row);
        //         totalSavingsRow.values = [
        //             "Total Amount Of Savings (GH¢)",
        //             this.displayNumber(this.total_active_savings_members + this.total_inactive_savings_members + this.total_dormant_savings_members),
        //             this.displayNumber(this.active_female_savings + this.inactive_female_savings + this.dormant_female_savings),
        //             this.displayNumber(this.active_male_savings + this.inactive_male_savings + this.dormant_male_savings),
        //             this.displayNumber(this.active_group_savings + this.inactive_group_savings + this.dormant_group_savings)
        //         ];
        //         totalSavingsRow.font = { bold: true };
        //         row++;

        //         // Loans section
        //         ws.getRow(row).values = [
        //             "Number of loans disbursed during the period",
        //             this.total_disbursement_count,
        //             this.disbursement_female_count,
        //             this.disbursement_male_count,
        //             this.disbursement_group_count
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Amount of loans disbursed during the period (GH¢)",
        //             this.displayNumber(this.total_disbursement_sum),
        //             this.displayNumber(this.disbursement_female_sum),
        //             this.displayNumber(this.disbursement_male_sum),
        //             this.displayNumber(this.disbursement_group_sum)
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Number of Loans Outstanding",
        //             this.total_oustanding_loan,
        //             this.oustanding_female_loan_count,
        //             this.oustanding_male_loan_count,
        //             this.oustanding_group_loan_count
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Amount of Loans Outstanding (GH¢)",
        //             this.displayNumber(this.oustanding_loan_sum),
        //             this.displayNumber(this.oustanding_female_loan_sum),
        //             this.displayNumber(this.oustanding_male_loan_sum),
        //             this.displayNumber(this.oustanding_group_loan_sum)
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "No. of Delinquent Borrowers (arrears of 30 days and more):",
        //             this.total_delinquent_count,
        //             this.delinquent_female_count,
        //             this.delinquent_male_count,
        //             this.delinquent_group_count
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Amount of Delinquent Loans (GH¢)",
        //             this.displayNumber(this.delinquent_sum),
        //             this.displayNumber(this.delinquent_female_sum),
        //             this.displayNumber(this.delinquent_male_sum),
        //             this.displayNumber(this.delinquent_group_sum)
        //         ]; row++;

        //         ws.getRow(row).values = [
        //             "Amount of Youth Savings (GH¢)",
        //             this.displayNumber(0),
        //             this.displayNumber(0),
        //             this.displayNumber(0),
        //             this.displayNumber(0)
        //         ]; row++;

        //         // Delinquency Rate row with bold formatting
        //         const delinquencyRateRow = ws.getRow(row);
        //         delinquencyRateRow.values = [
        //             "Deliquency Rate (%)",
        //             `${this.deliquencyRate}%`,
        //             "0%",
        //             "0%",
        //             "0%"
        //         ];
        //         delinquencyRateRow.font = { bold: true };
        //         row++;

        //         ws.getRow(row).values = [
        //             "Standard:",
        //             "0",
        //             "",
        //             "",
        //             ""
        //         ]; row += 3;

        //         // RECEIPTS AND PAYMENTS
        //         ws.getCell(`A${row}`).value = "RECEIPTS AND PAYMENTS";
        //         ws.getCell(`A${row}`).font = { bold: true, size: 14 };
        //         row++;

        //         // Receipts section
        //         ws.getRow(row).values = ["Receipts", "Amount (GHS)"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         // Loop through COA heads for receipts
        //         (this.coa_heads || []).forEach(coa_type => {
        //             // Add COA type name as a bold row
        //             ws.getRow(row).values = [coa_type.type_name];
        //             ws.getRow(row).font = { bold: true };
        //             row++;

        //             (coa_type.coa_heads || []).forEach(coa_head => {
        //                 ws.getRow(row).values = [
        //                     coa_head.display_name,
        //                     `${this.institution?.currency_code} ${this.displayNumber(Number(coa_head.total_receipts).toFixed(2))}`
        //                 ];
        //                 row++;
        //             });

        //             // Total for this COA type receipts
        //             ws.getRow(row).values = [
        //                 "TOTAL",
        //                 `${this.institution?.currency_code} ${this.displayNumber(Number(coa_type.total_receipts).toFixed(2))}`
        //             ];
        //             ws.getRow(row).font = { bold: true };
        //             row++;
        //         });

        //         // After looping through receipts and totals
        //         const totalIncomeRow = ws.getRow(row);
        //         totalIncomeRow.values = [
        //             "Total Income",
        //             `${this.institution?.currency_code} ${this.displayNumber(Number(this.total_incomes).toFixed(2))}`
        //         ];
        //         totalIncomeRow.font = { bold: true };
        //         row++;

        //         const totalReceiptsRow = ws.getRow(row);
        //         totalReceiptsRow.values = [
        //             "Total Receipts",
        //             `${this.institution?.currency_code} ${this.displayNumber(Number(this.total_receipts).toFixed(2))}`
        //         ];
        //         totalReceiptsRow.font = { bold: true };
        //         row += 2;

        //         // Payments section
        //         ws.getRow(row).values = ["Payments", "Amount (GHS)"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         // Loop through COA heads for payments
        //         (this.coa_heads || []).forEach(coa_type => {
        //             // Add COA type name as a bold row
        //             ws.getRow(row).values = [coa_type.type_name];
        //             ws.getRow(row).font = { bold: true };
        //             row++;

        //             (coa_type.coa_heads || []).forEach(coa_head => {
        //                 ws.getRow(row).values = [
        //                     coa_head.display_name,
        //                     `${this.institution?.currency_code} ${this.displayNumber(Number(coa_head.total_payments).toFixed(2))}`
        //                 ];
        //                 row++;
        //             });

        //             // Total for this COA type payments
        //             ws.getRow(row).values = [
        //                 "TOTAL",
        //                 `${this.institution?.currency_code} ${this.displayNumber(Number(coa_type.total_payments).toFixed(2))}`
        //             ];
        //             ws.getRow(row).font = { bold: true };
        //             row++;
        //         });
        //         const totalExpensesRow = ws.getRow(row);
        //         totalExpensesRow.values = [
        //             "Total Expenses",
        //             `${this.institution?.currency_code} ${this.displayNumber(Number(this.total_expenses).toFixed(2))}`
        //         ];
        //         totalExpensesRow.font = { bold: true };
        //         row++;

        //         // Difference row
        //         const differenceRow = ws.getRow(row);
        //         differenceRow.values = [
        //             "Difference",
        //             `${this.institution?.currency_code} ${this.displayNumber(Number(this.difference).toFixed(2))}`
        //         ];
        //         differenceRow.font = { bold: true };
        //         row++;

        //         const totalPaymentsRow = ws.getRow(row);
        //         totalPaymentsRow.values = [
        //             "Total Payments",
        //             `${this.institution?.currency_code} ${this.displayNumber(Number(this.total_payments).toFixed(2))}`
        //         ];
        //         totalPaymentsRow.font = { bold: true };
        //         row += 3;

        //         // INCOME SUMMARY
        //         ws.getCell(`A${row}`).value = `NOTES TO THE STATEMENT OF COMPREHENSIVE INCOME AND EXPENSES FOR ${this.getDateString}`;
        //         ws.getCell(`A${row}`).font = { bold: true, size: 14 };
        //         row += 2;

        //         ws.getRow(row).values = ["INCOME SUMMARY"];
        //         ws.getRow(row).font = { bold: true, size: 12 };
        //         row++;

        //         ws.getRow(row).values = ["GL Code", "GL Name", "Income Current Month", "Income Year to Date"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         (this.incomes || []).forEach(income => {
        //             ws.getRow(row).values = [
        //                 income.code,
        //                 income.name,
        //                 `${this.institution?.currency_code} ${this.displayNumber(income.total_monthly_amount)}`,
        //                 `${this.institution?.currency_code} ${this.displayNumber(income.total_yearly_amount)}`
        //             ];
        //             row++;
        //         });

        //         const totalIncomeRow = ws.getRow(row);
        //         totalIncomeRow.values = [
        //             "Total Income",
        //             "",
        //             `${this.institution?.currency_code} ${this.displayNumber(this.grant_monthly_total_incomes ? this.grant_monthly_total_incomes.toFixed(2) : 0)}`,
        //             `${this.institution?.currency_code} ${this.displayNumber(this.grant_yearly_total_incomes ? this.grant_yearly_total_incomes.toFixed(2) : 0)}`
        //         ];
        //         totalIncomeRow.font = { bold: true };
        //         row += 2;

        //         // EXPENSES SUMMARY
        //         ws.getRow(row).values = ["EXPENSES SUMMARY"];
        //         ws.getRow(row).font = { bold: true, size: 12 };
        //         row++;

        //         ws.getRow(row).values = ["GL Code", "GL Name", "Expense Current Month", "Expense Year to Date"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         (this.expenses || []).forEach(expense => {
        //             ws.getRow(row).values = [
        //                 expense.code,
        //                 expense.name,
        //                 `${this.institution?.currency_code} ${this.displayNumber(Number(expense.total_monthly_amount).toFixed(2))}`,
        //                 `${this.institution?.currency_code} ${this.displayNumber(Number(expense.total_yearly_amount).toFixed(2))}`
        //             ];
        //             row++;
        //         });

        //         const totalExpensesRow = ws.getRow(row);
        //         totalExpensesRow.values = [
        //             "Total Expenses",
        //             "",
        //             `${this.institution?.currency_code} ${this.displayNumber(this.grant_monthly_total_expenses ? this.grant_monthly_total_expenses.toFixed(2) : 0)}`,
        //             `${this.institution?.currency_code} ${this.displayNumber(this.grant_yearly_total_expenses ? this.grant_yearly_total_expenses.toFixed(2) : 0)}`
        //         ];
        //         totalExpensesRow.font = { bold: true };
        //         row++;

        //         // Profit/Loss row
        //         const profitLossRow = ws.getRow(row);
        //         profitLossRow.values = [
        //             "Profit / Loss (GHS)",
        //             "",
        //             `${this.institution?.currency_code} ${this.displayNumber(this.profit_or_loss_monthly ? Math.abs(this.profit_or_loss_monthly).toFixed(2) : 0)} ${this.profit_or_loss_monthly < 0 ? '(Loss)' : '(Profit)'}`,
        //             `${this.institution?.currency_code} ${this.displayNumber(this.profit_or_loss_yearly ? Math.abs(this.profit_or_loss_yearly).toFixed(2) : 0)} ${this.profit_or_loss_yearly < 0 ? '(Loss)' : '(Profit)'}`
        //         ];
        //         profitLossRow.font = { bold: true };
        //         row += 3;

        //         // STATEMENT OF FINANCIAL POSITION
        //         ws.getCell(`A${row}`).value = `STATEMENT OF FINANCIAL POSITION (BALANCE SHEET) AS AT ${this.getDateString}`;
        //         ws.getCell(`A${row}`).font = { bold: true, size: 14 };
        //         row += 2;

        //         // Assets section
        //         ws.getRow(row).values = ["ASSETS"];
        //         ws.getRow(row).font = { bold: true, size: 12 };
        //         row++;

        //         ws.getRow(row).values = ["GL Code", "GL Name", "", "Amount"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         (this.assets_items || []).forEach(asset => {
        //             const balance = asset.transactions && asset.transactions.length > 0 ? asset.transactions[0].balance : 0;
        //             ws.getRow(row).values = [
        //                 asset.code,
        //                 asset.display_name,
        //                 "",
        //                 `${this.institution?.currency_code} ${this.displayNumber(Number(balance).toFixed(2))}`
        //             ];
        //             row++;
        //         });

        //         ws.getRow(row).values = ["Gross Asset", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.grant_total_assets).toFixed(2))}`];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         ws.getRow(row).values = ["PROVISION FOR LOAN LOSSES", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.loan_losses).toFixed(2))}`];
        //         row++;

        //         ws.getRow(row).values = ["ACCUMULATED DEPRECIATION", "", "", `${this.institution?.currency_code} ${this.displayNumber(this.accumulated_dep)}`];
        //         row++;

        //         const netAssetsRow = ws.getRow(row);
        //         netAssetsRow.values = ["Net Asset", "", "", `${this.institution?.currency_code} ${this.displayNumber(this.grant_total_assets - (this.accumulated_dep - this.loan_losses))}`];
        //         netAssetsRow.font = { bold: true };
        //         row += 2;

        //         // Liabilities + Capital section
        //         ws.getRow(row).values = ["LIABILITIES + CAPITAL"];
        //         ws.getRow(row).font = { bold: true, size: 12 };
        //         row++;

        //         ws.getRow(row).values = ["GL Code", "GL Name", "", "Amount"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         (this.liability_items || []).forEach(liability => {
        //             const balance = liability.transactions && liability.transactions.length > 0 ? liability.transactions[0].balance : 0;
        //             ws.getRow(row).values = [
        //                 liability.code,
        //                 liability.display_name,
        //                 "",
        //                 `${this.institution?.currency_code} ${this.displayNumber(balance)}`
        //             ];
        //             row++;
        //         });

        //         // Surpluses
        //         Object.values(this.surpluses || {}).forEach(surplus => {
        //             const balance = surplus.transactions && surplus.transactions.length > 0 ? surplus.transactions[0].balance : 0;
        //             ws.getRow(row).values = [
        //                 surplus.code || "",
        //                 surplus.display_name,
        //                 "",
        //                 `${this.institution?.currency_code} ${this.displayNumber(balance)}`
        //             ];
        //             row++;
        //         });

        //         ws.getRow(row).values = ["Total Liability", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.grant_total_liabilities).toFixed(2))}`];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         ws.getRow(row).values = ["Total Surplus", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.grant_total_surpluses).toFixed(2))}`];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         const totalLiabCapitalRow = ws.getRow(row);
        //         totalLiabCapitalRow.values = ["Total Liabilities + Surplus", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.liabilities_plus_surplus).toFixed(2))}`];
        //         totalLiabCapitalRow.font = { bold: true };
        //         row += 2;

        //         // Information on Ratio
        //         ws.getRow(row).values = ["Information on Ratio"];
        //         ws.getRow(row).font = { bold: true, size: 12 };
        //         row++;

        //         ws.getRow(row).values = ["Liquidity Reserve", `${this.liquidity_res}%`, "(Total liquid Funds / total assets * 100)"]; row++;
        //         ws.getRow(row).values = ["Return on Asset", `${this.return_on_assets}%`, "(Surplus difference / total assets * 100)"]; row++;
        //         ws.getRow(row).values = ["Capital Adequacy", `${this.capital_adequacy}%`, "([Member Shares + total capital res] / total assets * 100)"]; row += 2;

        //         ws.getRow(row).values = ["Prepared By", "", "Certified By"]; row++;
        //         ws.getRow(row).values = ["Accountant", "", "Manager/Board Treasurer"]; row++;
        //         ws.getRow(row).values = ["Signature", "", "Signature"]; row += 3;

        //         // OTHER INFORMATION
        //         ws.getCell(`A${row}`).value = `OTHER INFORMATION - ${this.getDateString}`;
        //         ws.getCell(`A${row}`).font = { bold: true, size: 14 };
        //         row += 2;

        //         ws.getRow(row).values = ["", "In Place (Yes/No)", "Regular Meetings Date", "No of meeting in period"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         ws.getRow(row).values = ["Management Committee", "", "", ""]; row++;
        //         ws.getRow(row).values = ["Supervisory Committee", "", "", ""]; row++;
        //         ws.getRow(row).values = ["Loan Committee", "", "", ""]; row++;
        //         ws.getRow(row).values = ["Education Committee", "", "", ""]; row += 3;

        //         // EMPLOYEES INFORMATION
        //         ws.getCell(`A${row}`).value = `EMPLOYEES INFORMATION - ${this.getDateString}`;
        //         ws.getCell(`A${row}`).font = { bold: true, size: 14 };
        //         row += 2;

        //         ws.getRow(row).values = ["", "Total", "Male", "Female"];
        //         ws.getRow(row).font = { bold: true };
        //         row++;

        //         ws.getRow(row).values = ["No of Permanent Employees", "", "", ""]; row++;
        //         ws.getRow(row).values = ["No of Temporal Employees", "", "", ""]; row++;
        //         ws.getRow(row).values = ["No of Employees covered under CCUPP", "", "", ""]; row++;

        //         const totalEmployeesRow = ws.getRow(row);
        //         totalEmployeesRow.values = ["Total Number Of Employees", "", "", ""];
        //         totalEmployeesRow.font = { bold: true };
        //         row += 3;

        //         // Final signature section
        //         ws.getRow(row).values = ["Prepared By:", "", "Approved By:"]; row += 2;
        //         ws.getRow(row).values = ["____________________________________", "", "____________________________________"]; row++;
        //         ws.getRow(row).values = ["Signature", "", "Signature"]; row++;

        //         // Auto-fit columns
        //         ws.columns.forEach(col => {
        //             let maxLength = 10;
        //             col.eachCell({ includeEmpty: true }, cell => {
        //                 const cellValue = cell.value ? cell.value.toString() : "";
        //                 maxLength = Math.max(maxLength, cellValue.length);
        //             });
        //             col.width = Math.min(maxLength + 2, 50);
        //         });

        //         // Save and download
        //         const buffer = await wb.xlsx.writeBuffer();
        //         const blob = new Blob([buffer], {
        //             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        //         });
        //         const link = document.createElement("a");
        //         link.href = URL.createObjectURL(blob);
        //         link.download = "Account_Statistics_Report.xlsx";
        //         document.body.appendChild(link);
        //         link.click();
        //         document.body.removeChild(link);

        //     } catch (err) {
        //         console.error("Error generating Excel file:", err);
        //         alert("Error generating Excel file. Please try again.");
        //     }
        // },

        async generateExcel() {
            const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx";
            const imageUrl = "/default_logo.png";

            // Institution details
            const institutionName = this.institution?.name || "";
            const institutionMotto = this.institution?.motto || "";
            const institutionAddress = this.institution?.address || "";
            const institutionPhone = this.institution?.telephone || "";
            const institutionEmail = this.institution?.email || "";
            const dateRange = `FROM: ${this.form.start_date} TO: ${this.form.end_date}`;

            try {
                // Fetch and load template
                const response = await fetch(fileUrl);
                if (!response.ok) throw new Error(`Failed to fetch template: ${response.statusText}`);
                const arrayBuffer = await response.arrayBuffer();
                const wb = new ExcelJS.Workbook();
                await wb.xlsx.load(arrayBuffer);
                const ws = wb.getWorksheet(1);

                // Add logo
                const imageResponse = await fetch(imageUrl);
                const imageBuffer = await imageResponse.arrayBuffer();
                const imageId = wb.addImage({ buffer: imageBuffer, extension: "png" });
                ws.addImage(imageId, { tl: { col: 0, row: 0 }, ext: { width: 150, height: 80 } });

                // Institution details
                ws.getCell("E1").value = institutionName;
                ws.getCell("E2").value = institutionAddress;
                ws.getCell("E3").value = institutionMotto;
                ws.getCell("E4").value = institutionPhone;
                ws.getCell("E5").value = institutionEmail;
                ws.getCell("E6").value = dateRange;

                let row = 10;

                // MEMBERSHIP INFORMATION
                ws.getCell(`A${row}`).value = "MEMBERSHIP INFORMATION";
                ws.getCell(`A${row}`).font = { bold: true, size: 14 };
                row++;

                ws.getRow(row).values = ["", "Total", "Females", "Males", "Groups"];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = [
                    "Active Members",
                    this.total_active_member,
                    this.active_female,
                    this.active_male,
                    this.active_group
                ]; row++;

                ws.getRow(row).values = [
                    "Inactive Members",
                    this.total_inactive_member,
                    this.inactive_female,
                    this.inactive_male,
                    this.inactive_group
                ]; row++;

                ws.getRow(row).values = [
                    "Dormant Members",
                    this.total_dormant_member,
                    this.dormant_female,
                    this.dormant_male,
                    this.dormant_group
                ]; row++;

                ws.getRow(row).values = [
                    "Total Membership",
                    this.total_member,
                    this.total_female,
                    this.total_male,
                    this.total_group
                ];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = [
                    "Number of person in group (If Available)",
                    "",
                    "",
                    "",
                    ""
                ]; row++;

                ws.getRow(row).values = [
                    "Number of Youth Savers (if applicable)",
                    "",
                    "",
                    "",
                    ""
                ]; row++;

                ws.getRow(row).values = [
                    "Number of Mobile Banking Client (if available)",
                    "",
                    "",
                    "",
                    ""
                ]; row += 3;

                // MEMBERS DEPOSIT AND LOANS
                ws.getCell(`A${row}`).value = "MEMBERS DEPOSIT AND LOANS";
                ws.getCell(`A${row}`).font = { bold: true, size: 14 };
                row++;

                ws.getRow(row).values = ["", "Total", "Females", "Males", "Groups"];
                ws.getRow(row).font = { bold: true };
                row++;

                // Shares section
                ws.getRow(row).values = [
                    "Amount of Active Shares (GH¢)",
                    this.displayNumber(this.total_active_shares_members),
                    this.displayNumber(this.active_female_shares),
                    this.displayNumber(this.active_male_shares),
                    this.displayNumber(this.active_group_shares)
                ]; row++;

                ws.getRow(row).values = [
                    "Amount of Inactive Shares (GH¢)",
                    this.displayNumber(this.total_inactive_shares_members),
                    this.displayNumber(this.inactive_female_shares),
                    this.displayNumber(this.inactive_male_shares),
                    this.displayNumber(this.inactive_group_shares)
                ]; row++;

                ws.getRow(row).values = [
                    "Amount of Dormant Shares (GH¢)",
                    this.displayNumber(this.total_dormant_shares_members),
                    this.displayNumber(this.dormant_female_shares),
                    this.displayNumber(this.dormant_male_shares),
                    this.displayNumber(this.dormant_group_shares)
                ]; row++;

                ws.getRow(row).values = [
                    "Total Amount of Shares (GH¢)",
                    this.displayNumber(this.total_active_shares_members + this.total_inactive_shares_members + this.total_dormant_shares_members),
                    this.displayNumber(this.active_female_shares + this.inactive_female_shares + this.dormant_female_shares),
                    this.displayNumber(this.active_male_shares + this.inactive_male_shares + this.dormant_male_shares),
                    this.displayNumber(this.active_group_shares + this.inactive_group_shares + this.dormant_group_shares)
                ];
                ws.getRow(row).font = { bold: true };
                row++;

                // Savings section
                ws.getRow(row).values = [
                    "Amount of Active Savings (GH¢)",
                    this.displayNumber(this.total_active_savings_members),
                    this.displayNumber(this.active_female_savings),
                    this.displayNumber(this.active_male_savings),
                    this.displayNumber(this.active_group_savings)
                ]; row++;

                ws.getRow(row).values = [
                    "Amount of Inactive Savings (GH¢)",
                    this.displayNumber(this.total_inactive_savings_members),
                    this.displayNumber(this.inactive_female_savings),
                    this.displayNumber(this.inactive_male_savings),
                    this.displayNumber(this.inactive_group_savings)
                ]; row++;

                ws.getRow(row).values = [
                    "Amount of Dormant Savings (GH¢)",
                    this.displayNumber(this.total_dormant_savings_members),
                    this.displayNumber(this.dormant_female_savings),
                    this.displayNumber(this.dormant_male_savings),
                    this.displayNumber(this.dormant_group_savings)
                ]; row++;

                ws.getRow(row).values = [
                    "Total Amount Of Savings (GH¢)",
                    this.displayNumber(this.total_active_savings_members + this.total_inactive_savings_members + this.total_dormant_savings_members),
                    this.displayNumber(this.active_female_savings + this.inactive_female_savings + this.dormant_female_savings),
                    this.displayNumber(this.active_male_savings + this.inactive_male_savings + this.dormant_male_savings),
                    this.displayNumber(this.active_group_savings + this.inactive_group_savings + this.dormant_group_savings)
                ];
                ws.getRow(row).font = { bold: true };
                row++;

                // Loans section
                ws.getRow(row).values = [
                    "Number of loans disbursed during the period",
                    this.total_disbursement_count,
                    this.disbursement_female_count,
                    this.disbursement_male_count,
                    this.disbursement_group_count
                ]; row++;

                ws.getRow(row).values = [
                    "Amount of loans disbursed during the period (GH¢)",
                    this.displayNumber(this.total_disbursement_sum),
                    this.displayNumber(this.disbursement_female_sum),
                    this.displayNumber(this.disbursement_male_sum),
                    this.displayNumber(this.disbursement_group_sum)
                ]; row++;

                ws.getRow(row).values = [
                    "Number of Loans Outstanding",
                    this.total_oustanding_loan,
                    this.oustanding_female_loan_count,
                    this.oustanding_male_loan_count,
                    this.oustanding_group_loan_count
                ]; row++;

                ws.getRow(row).values = [
                    "Amount of Loans Outstanding (GH¢)",
                    this.displayNumber(this.oustanding_loan_sum),
                    this.displayNumber(this.oustanding_female_loan_sum),
                    this.displayNumber(this.oustanding_male_loan_sum),
                    this.displayNumber(this.oustanding_group_loan_sum)
                ]; row++;

                ws.getRow(row).values = [
                    "No. of Delinquent Borrowers (arrears of 30 days and more):",
                    this.total_delinquent_count,
                    this.delinquent_female_count,
                    this.delinquent_male_count,
                    this.delinquent_group_count
                ]; row++;

                ws.getRow(row).values = [
                    "Amount of Delinquent Loans (GH¢)",
                    this.displayNumber(this.delinquent_sum),
                    this.displayNumber(this.delinquent_female_sum),
                    this.displayNumber(this.delinquent_male_sum),
                    this.displayNumber(this.delinquent_group_sum)
                ]; row++;

                ws.getRow(row).values = [
                    "Amount of Youth Savings (GH¢)",
                    this.displayNumber(0),
                    this.displayNumber(0),
                    this.displayNumber(0),
                    this.displayNumber(0)
                ]; row++;

                ws.getRow(row).values = [
                    "Deliquency Rate (%)",
                    `${this.deliquencyRate}%`,
                    "0%",
                    "0%",
                    "0%"
                ];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = [
                    "Standard:",
                    "Not more than 5%",
                    "",
                    "",
                    ""
                ]; row += 3;

                // RECEIPTS AND PAYMENTS
                ws.getCell(`A${row}`).value = "RECEIPTS AND PAYMENTS";
                ws.getCell(`A${row}`).font = { bold: true, size: 14 };
                row++;

                // Receipts section
                ws.getRow(row).values = ["Receipts", "Amount (GHS)"];
                ws.getRow(row).font = { bold: true };
                row++;

                (this.coa_heads || []).forEach(coa_type => {
                    ws.getRow(row).values = [coa_type.type_name];
                    ws.getRow(row).font = { bold: true };
                    row++;

                    (coa_type.coa_heads || []).forEach(coa_head => {
                        ws.getRow(row).values = [
                            coa_head.display_name,
                            `${this.institution?.currency_code} ${this.displayNumber(Number(coa_head.total_receipts).toFixed(2))}`
                        ];
                        row++;
                    });

                    ws.getRow(row).values = [
                        "TOTAL",
                        `${this.institution?.currency_code} ${this.displayNumber(Number(coa_type.total_receipts).toFixed(2))}`
                    ];
                    ws.getRow(row).font = { bold: true };
                    row++;
                });

                ws.getRow(row).values = [
                    "Total Income",
                    `${this.institution?.currency_code} ${this.displayNumber(Number(this.total_incomes).toFixed(2))}`
                ];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = [
                    "Total Receipts",
                    `${this.institution?.currency_code} ${this.displayNumber(Number(this.total_receipts).toFixed(2))}`
                ];
                ws.getRow(row).font = { bold: true };
                row += 2;

                // Payments section
                ws.getRow(row).values = ["Payments", "Amount (GHS)"];
                ws.getRow(row).font = { bold: true };
                row++;

                (this.coa_heads || []).forEach(coa_type => {
                    ws.getRow(row).values = [coa_type.type_name];
                    ws.getRow(row).font = { bold: true };
                    row++;

                    (coa_type.coa_heads || []).forEach(coa_head => {
                        ws.getRow(row).values = [
                            coa_head.display_name,
                            `${this.institution?.currency_code} ${this.displayNumber(Number(coa_head.total_payments).toFixed(2))}`
                        ];
                        row++;
                    });

                    ws.getRow(row).values = [
                        "TOTAL",
                        `${this.institution?.currency_code} ${this.displayNumber(Number(coa_type.total_payments).toFixed(2))}`
                    ];
                    ws.getRow(row).font = { bold: true };
                    row++;
                });

                ws.getRow(row).values = [
                    "Total Expenses",
                    `${this.institution?.currency_code} ${this.displayNumber(Number(this.total_expenses).toFixed(2))}`
                ];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = [
                    "Profit/Loss",
                    `${this.institution?.currency_code} ${this.displayNumber(Number(this.difference).toFixed(2))}`
                ];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = [
                    "Total Payments",
                    `${this.institution?.currency_code} ${this.displayNumber(Number(this.total_payments).toFixed(2))}`
                ];
                ws.getRow(row).font = { bold: true };
                row += 3;

                // INCOME SUMMARY
                ws.getCell(`A${row}`).value = `NOTES TO THE STATEMENT OF COMPREHENSIVE INCOME AND EXPENSES FOR ${this.getDateString}`;
                ws.getCell(`A${row}`).font = { bold: true, size: 14 };
                row += 2;

                ws.getRow(row).values = ["INCOME SUMMARY"];
                ws.getRow(row).font = { bold: true, size: 12 };
                row++;

                ws.getRow(row).values = ["GL Code", "GL Name", "Income Current Month", "Income Year to Date"];
                ws.getRow(row).font = { bold: true };
                row++;

                (this.incomes || []).forEach(income => {
                    ws.getRow(row).values = [
                        income.code,
                        income.name,
                        `${this.institution?.currency_code} ${this.displayNumber(income.total_monthly_amount)}`,
                        `${this.institution?.currency_code} ${this.displayNumber(income.total_yearly_amount)}`
                    ];
                    row++;
                });

                ws.getRow(row).values = [
                    "Total Income",
                    "",
                    `${this.institution?.currency_code} ${this.displayNumber(this.grant_monthly_total_incomes ? this.grant_monthly_total_incomes.toFixed(2) : 0)}`,
                    `${this.institution?.currency_code} ${this.displayNumber(this.grant_yearly_total_incomes ? this.grant_yearly_total_incomes.toFixed(2) : 0)}`
                ];
                ws.getRow(row).font = { bold: true };
                row += 2;

                // EXPENSES SUMMARY
                ws.getRow(row).values = ["EXPENSES SUMMARY"];
                ws.getRow(row).font = { bold: true, size: 12 };
                row++;

                ws.getRow(row).values = ["GL Code", "GL Name", "Expense Current Month", "Expense Year to Date"];
                ws.getRow(row).font = { bold: true };
                row++;

                (this.expenses || []).forEach(expense => {
                    ws.getRow(row).values = [
                        expense.code,
                        expense.name,
                        `${this.institution?.currency_code} ${this.displayNumber(Number(expense.total_monthly_amount).toFixed(2))}`,
                        `${this.institution?.currency_code} ${this.displayNumber(Number(expense.total_yearly_amount).toFixed(2))}`
                    ];
                    row++;
                });

                ws.getRow(row).values = [
                    "Total Expenses",
                    "",
                    `${this.institution?.currency_code} ${this.displayNumber(this.grant_monthly_total_expenses ? this.grant_monthly_total_expenses.toFixed(2) : 0)}`,
                    `${this.institution?.currency_code} ${this.displayNumber(this.grant_yearly_total_expenses ? this.grant_yearly_total_expenses.toFixed(2) : 0)}`
                ];
                ws.getRow(row).font = { bold: true };
                row++;

                // Profit/Loss row
                ws.getRow(row).values = [
                    "Profit / Loss (GHS)",
                    "",
                    `${this.institution?.currency_code} ${this.displayNumber(this.profit_or_loss_monthly ? Math.abs(this.profit_or_loss_monthly).toFixed(2) : 0)} ${this.profit_or_loss_monthly < 0 ? '(Loss)' : '(Profit)'}`,
                    `${this.institution?.currency_code} ${this.displayNumber(this.profit_or_loss_yearly ? Math.abs(this.profit_or_loss_yearly).toFixed(2) : 0)} ${this.profit_or_loss_yearly < 0 ? '(Loss)' : '(Profit)'}`
                ];
                ws.getRow(row).font = { bold: true };
                row += 3;

                // STATEMENT OF FINANCIAL POSITION
                ws.getCell(`A${row}`).value = `STATEMENT OF FINANCIAL POSITION (BALANCE SHEET) AS AT ${this.getDateString}`;
                ws.getCell(`A${row}`).font = { bold: true, size: 14 };
                row += 2;

                // Assets section
                ws.getRow(row).values = ["ASSETS"];
                ws.getRow(row).font = { bold: true, size: 12 };
                row++;

                ws.getRow(row).values = ["GL Code", "GL Name", "", "Amount"];
                ws.getRow(row).font = { bold: true };
                row++;

                (this.assets_items || []).forEach(asset => {
                    const balance = asset.transactions && asset.transactions.length > 0 ? asset.transactions[0].balance : 0;
                    ws.getRow(row).values = [
                        asset.code,
                        asset.display_name,
                        "",
                        `${this.institution?.currency_code} ${this.displayNumber(Number(balance).toFixed(2))}`
                    ];
                    row++;
                });

                ws.getRow(row).values = ["Gross Asset", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.grant_total_assets).toFixed(2))}`];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = ["PROVISION FOR LOAN LOSSES", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.loan_losses).toFixed(2))}`];
                row++;

                ws.getRow(row).values = ["ACCUMULATED DEPRECIATION", "", "", `${this.institution?.currency_code} ${this.displayNumber(this.accumulated_dep)}`];
                row++;

                ws.getRow(row).values = ["Net Asset", "", "", `${this.institution?.currency_code} ${this.displayNumber(this.net_assets)}`];
                ws.getRow(row).font = { bold: true };
                row += 2;

                // Liabilities + Capital section
                ws.getRow(row).values = ["LIABILITIES + CAPITAL"];
                ws.getRow(row).font = { bold: true, size: 12 };
                row++;

                ws.getRow(row).values = ["GL Code", "GL Name", "", "Amount"];
                ws.getRow(row).font = { bold: true };
                row++;

                (this.liability_items || []).forEach(liability => {
                    const balance = liability.transactions && liability.transactions.length > 0 ? liability.transactions[0].balance : 0;
                    ws.getRow(row).values = [
                        liability.code,
                        liability.display_name,
                        "",
                        `${this.institution?.currency_code} ${this.displayNumber(balance)}`
                    ];
                    row++;
                });

                Object.values(this.surpluses || {}).forEach(surplus => {
                    const balance = surplus.transactions && surplus.transactions.length > 0 ? surplus.transactions[0].balance : 0;
                    ws.getRow(row).values = [
                        surplus.code || "",
                        surplus.display_name,
                        "",
                        `${this.institution?.currency_code} ${this.displayNumber(balance)}`
                    ];
                    row++;
                });

                ws.getRow(row).values = ["Total Liability", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.grant_total_liabilities).toFixed(2))}`];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = ["Total Surplus", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.grant_total_surpluses).toFixed(2))}`];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = ["Total Liabilities + Surplus", "", "", `${this.institution?.currency_code} ${this.displayNumber(Number(this.liabilities_plus_surplus).toFixed(2))}`];
                ws.getRow(row).font = { bold: true };
                row += 2;

                // Information on Ratio
                ws.getRow(row).values = ["Information on Ratio"];
                ws.getRow(row).font = { bold: true, size: 12 };
                row++;

                ws.getRow(row).values = ["Liquidity Reserve", `${this.liquidity_res}%`, "(Total liquid Funds / total assets * 100)"]; row++;
                ws.getRow(row).values = ["Return on Asset", `${this.return_on_assets}%`, "(Surplus difference / total assets * 100)"]; row++;
                ws.getRow(row).values = ["Capital Adequacy", `${this.capital_adequacy}%`, "([Member Shares + total capital res] / total assets * 100)"]; row += 2;

                ws.getRow(row).values = ["Prepared By", "", "Certified By"]; row++;
                ws.getRow(row).values = ["Accountant", "", "Manager/Board Treasurer"]; row++;
                ws.getRow(row).values = ["Signature", "", "Signature"]; row += 3;

                // OTHER INFORMATION
                ws.getCell(`A${row}`).value = `OTHER INFORMATION - ${this.getDateString}`;
                ws.getCell(`A${row}`).font = { bold: true, size: 14 };
                row += 2;

                ws.getRow(row).values = ["", "In Place (Yes/No)", "Regular Meetings Date", "No of meeting in period"];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = ["Management Committee", "", "", ""]; row++;
                ws.getRow(row).values = ["Supervisory Committee", "", "", ""]; row++;
                ws.getRow(row).values = ["Loan Committee", "", "", ""]; row++;
                ws.getRow(row).values = ["Education Committee", "", "", ""]; row += 3;

                // EMPLOYEES INFORMATION
                ws.getCell(`A${row}`).value = `EMPLOYEES INFORMATION - ${this.getDateString}`;
                ws.getCell(`A${row}`).font = { bold: true, size: 14 };
                row += 2;

                ws.getRow(row).values = ["", "Total", "Male", "Female"];
                ws.getRow(row).font = { bold: true };
                row++;

                ws.getRow(row).values = ["No of Permanent Employees", "", "", ""]; row++;
                ws.getRow(row).values = ["No of Temporal Employees", "", "", ""]; row++;
                ws.getRow(row).values = ["No of Employees covered under CCUPP", "", "", ""]; row++;

                ws.getRow(row).values = ["Total Number Of Employees", "", "", ""];
                ws.getRow(row).font = { bold: true };
                row += 3;

                // Final signature section
                ws.getRow(row).values = ["Prepared By:", "", "Approved By:"]; row += 2;
                ws.getRow(row).values = ["____________________________________", "", "____________________________________"]; row++;
                ws.getRow(row).values = ["Signature", "", "Signature"]; row++;

                // Auto-fit columns
                ws.columns.forEach(col => {
                    let maxLength = 10;
                    col.eachCell({ includeEmpty: true }, cell => {
                        const cellValue = cell.value ? cell.value.toString() : "";
                        maxLength = Math.max(maxLength, cellValue.length);
                    });
                    col.width = Math.min(maxLength + 2, 50);
                });

                // Save and download
                const buffer = await wb.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "Account_Statistics_Report.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (err) {
                console.error("Error generating Excel file:", err);
                alert("Error generating Excel file. Please try again.");
            }
        },

        // Add this helper method if it doesn't exist
        displayNumber(value) {
            if (value === null || value === undefined || value === "") return "0.00";
            const num = parseFloat(value);
            if (isNaN(num)) return "0.00";
            return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        // Add this helper method if it doesn't exist  
        getBeginningOfYear() {
            const now = new Date();
            const startOfYear = new Date(now.getFullYear(), 0, 1);
            return startOfYear.toISOString().split('T')[0];
        }
    },
};
</script>
<style>
.list-item {
    page-break-inside: avoid;
}
</style>
